<template>
    <div class="single-contact">
        <div class="single-contact__left">
            <div class="single-contact__left-headline">{{ headline }}</div>
            <div class="single-contact__left-subheadline">{{ subheadline }}</div>
        </div>
        <div class="single-contact__right">
            <div class="single-contact__right-tel"><a :href="getTelString()"><img src="/layout/od_stylebreaker_v1_1/images/phone-receiver.png">{{ telephone }}</a></div>
            <div class="single-contact__right-whatsapp"><a data-toggle="modal" data-target="#whatsapp_modal" href="#"><img src="/layout/od_stylebreaker_v1_1/images/whatsappbold.svg">{{ whatsapp }}</a></div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            headline:{
                type: String,
                default: "Du hast Fragen?"
            },
            subheadline:{
                type: String,
                default: "Wir beraten dich gerne"
            },
            telephone:{
                type: String,
                default: "09402/9388-966"
            },
            whatsapp:{
                type: String,
                default: "0160/98693-481"
            }
        },

        methods:{
            getTelString(){
                let telString = this.telephone;
                let regex = new RegExp("/", "g");
                telString = telString.replace(regex, "");
                regex = new RegExp("-", "g");
                telString = telString.replace(regex, "");

                telString = "tel:"+telString;

                return telString;
            }
        }
    }
</script>
